var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"notice-switch-tip-dialog",attrs:{"visible":_vm.isDialogShow,"width":"400px","mask-closable":false,"footer":null,"closable":true},on:{"update:visible":function($event){_vm.isDialogShow=$event},"cancel":function($event){_vm.isDialogShow=false}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }